<template>
  <b-container fluid>
    <b-row class="contact-row" align-h="center">
      <b-col cols="8">
				<b-container fluid>
					<b-row>
						<b-col lg="2">
							<img :src="imageSrc" alt="Logo" />
						</b-col>
						<b-col lg="10">
							<div class="contact-info" v-html="sanitizedText"></div>
						</b-col>
					</b-row>
				</b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
		icon: Object,
    contactInfo: String
  },
  computed: {
		imageSrc() {
      return `/strapi/${this.icon.data.attributes.url}`
    },
    sanitizedText() {
      return DOMPurify.sanitize(marked(this.contactInfo))
    }
  }
}
</script>

<style scoped src="@/assets/css/contact-info.css"/>
